import React, { FC, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../store/hooks';
import CreateChatDialog from '../../../../Chats/dialogs/CreateChatDialog';
import { ReactComponent as GotoChatIcon } from '../../../../../assets/gotoChat.icon.svg';
import { ReactComponent as AddChatIcon } from '../../../../../assets/addChat.icon.svg';
import { CHAT } from '../../../../../router/routes';
import { Tooltip } from '@mui/material';
import { tt } from '@i18n/tt';

interface IProps {
  chatId: number;
  ticketId: string;
  ticketNumber?: string;
  isTicketClosed?: boolean;
}

const TicketChatIcon: FC<IProps> = ({ chatId, ticketId, ticketNumber, isTicketClosed }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [openCreateNewChatDialog, setOpenCreateNewChatDialog] = useState<boolean>(false);

  const handleItemClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>): void => {
      event.stopPropagation();
      if (isTicketClosed) {
        return;
      }
      if (chatId) {
        navigate(CHAT.replace(':chatId', String(chatId)));
        return;
      }
      setOpenCreateNewChatDialog(true);
    },
    [navigate, chatId, isTicketClosed],
  );

  const handleChatCreated = useCallback(
    (chatId: number): void => {
      navigate(CHAT.replace(':chatId', String(chatId)));
    },
    [dispatch, ticketId],
  );

  return (
    <>
      <div
        onClick={handleItemClick}
        role="presentation"
      >
        {chatId ? (
          <Tooltip
            title={tt(isTicketClosed ? 'pages.chats.closeChat.tooltip' : 'pages.chats.openChat')}
          >
            <GotoChatIcon />
          </Tooltip>
        ) : (
          <Tooltip
            title={tt(isTicketClosed ? 'pages.chats.closeChat.tooltip' : 'pages.chats.createChat')}
          >
            <AddChatIcon />
          </Tooltip>
        )}
      </div>
      {openCreateNewChatDialog && (
        <CreateChatDialog
          ticketId={ticketId}
          ticketNumber={ticketNumber}
          open={openCreateNewChatDialog}
          onClose={() => {
            setOpenCreateNewChatDialog(false);
          }}
          onSubmit={handleChatCreated}
        />
      )}
    </>
  );
};

export default TicketChatIcon;
